import React from 'react';
import BasicInfo from './BasicInfo';
import AdditionalInfo from './AdditionalInfo';
import CommentsAndFiles from './CommentsAndFiles';
import { FormikData } from '../../helpers';
import { FormikErrors } from 'formik';
import { AssertsShape } from 'yup/lib/object';
import { FormStateHook } from '../../hooks/useFormState';
import { GappedContainer } from '../../style';
import styled from 'styled-components/native';
import { View } from 'react-native';
import { useAppTheme } from 'src/providers/AppThemeProvider';
import { ReducerState } from '../../model';
import PatientProfileAvatar from '../PatientProfileAvatar';

interface Props {
  values: FormikData;
  errors: FormikErrors<AssertsShape<any>>;
  setFieldValue: FormStateHook['setFieldValue'];
  patient: any;
  formAdvance: () => void;
  state: ReducerState;
  patientIsMutating: boolean;
  newPatientImageUri: string | null;
}

const EditInfo: React.FC<Props> = ({
  values,
  errors,
  setFieldValue,
  patient,
  formAdvance,
  state,
  patientIsMutating,
  newPatientImageUri
}) => {
  const { viewMode } = useAppTheme();

  return (
    <Row>
      <View>
        {viewMode.isMobile && (
          <PatientProfileAvatar
            state={state}
            patient={patient}
            newPatientImageUri={newPatientImageUri}
            setFieldValue={setFieldValue}
            patientIsMutating={patientIsMutating}
          />
        )}
        <GappedContainer>
          <BasicInfo values={values} setFieldValue={setFieldValue} errors={errors} />
          <AdditionalInfo values={values} setFieldValue={setFieldValue} errors={errors} />
          <CommentsAndFiles values={values} setFieldValue={setFieldValue} errors={errors} />
        </GappedContainer>
      </View>
    </Row>
  );
};

const Row = styled(View)`
  flex-direction: row;
`;

export default EditInfo;
